module.exports = __webpack_public_path__ + "assets/images/pressure_y.d7c7569e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/pressure_y.png
// module id = 760
// module chunks = 1